import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { HeroV2 } from "@/components/HeroV2";
import { Marquee } from "@/components/Marquee";
import { Experience } from "@/components/Experience";
import { Highlights } from "@/components/Highlights";
import { PerformersV2 } from "@/components/PerformersV2";
import { ChiefGuest } from "@/components/ChiefGuest";
import { EventDetails } from "@/components/EventDetails";
import { TicketsV2 } from "@/components/TicketsV2";
import { Venue } from "@/components/Venue";
import { SocialSection } from "@/components/SocialSection";
import { ShareSection } from "@/components/ShareSection";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { StickyCta } from "@/components/StickyCta";
import { initAnalytics, initScrollTracking } from "@/lib/analytics";
import { initLenis } from "@/lib/scroll";
import Console from "@/pages/Console";
import { PrivacyPage, TermsPage } from "@/pages/Legal";
import SponsorPage from "@/pages/Sponsor";
import ArtistPage from "@/pages/Artist";
import UshaMangeshkarPage from "@/pages/UshaMangeshkar";
import PreviewLanding from "@/pages/PreviewLanding";

function Landing() {
  useEffect(() => {
    initLenis();
    return initScrollTracking();
  }, []);

  return (
    <div className="min-h-screen bg-[#080705] text-[#F7F4EF] antialiased">
      <a
        href="#experience"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[80] focus:rounded-full focus:bg-[#D4AF37] focus:px-6 focus:py-3 focus:text-sm focus:font-bold focus:text-[#080705]"
      >
        Skip to content
      </a>
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <HeroV2 />
        <Marquee />
        <Experience />
        <Highlights />
        <PerformersV2 />
        <ChiefGuest />
        <EventDetails />
        <TicketsV2 />
        <Venue />
        <SocialSection />
        <ShareSection />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    initAnalytics(); // global: loads the shared Google tag on every route
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        {/* Kept for reference — HeroV2/PerformersV2/TicketsV2 are now also
            live on "/" (see Landing() above), so this route currently
            renders the same three sections as the homepage. */}
        <Route path="/preview" element={<PreviewLanding />} />
        <Route path="/console" element={<Console />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/sponsor" element={<SponsorPage />} />
        <Route path="/artist" element={<ArtistPage />} />
        <Route path="/usha-mangeshkar" element={<UshaMangeshkarPage />} />
      </Routes>
    </BrowserRouter>
  );
}
